import React from 'react';

const Play = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.4814 19.1377C27.0839 19.5548 27.0839 20.4455 26.4814 20.8626L15.7368 28.3011C15.0411 28.7828 14.0908 28.2848 14.0908 27.4387V12.5616C14.0908 11.7154 15.0411 11.2175 15.7368 11.6991L26.4814 19.1377Z"
      fill="white"
    />
  </svg>
);

export default React.memo(Play);
